export default "__VITE_ASSET__CfPvKdU$__"